import React, { FC } from 'react'
import { Dialog } from 'components/Dialog'
import styles from './DownloadLayerDialog.module.scss'
import { useTranslation } from 'react-i18next'
import { Stack } from 'components/Stack'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { Flex } from 'components/Flex'
import { Icon } from 'components/Icon'
import { useDownloadLayerCsv } from 'services/widget'

type DownloadLayerDialogProps = {
  isOpen: boolean
  onClose: () => void
  file: { name: string; url: string }
  layerid: number
  projectid: string
}

export const DownloadLayerDialog: FC<DownloadLayerDialogProps> = ({ isOpen, onClose, file, layerid, projectid }) => {
  const { t } = useTranslation()
  const [downloadLayerCsv, { status }] = useDownloadLayerCsv(projectid, layerid)

  function downloadCsv() {
    return downloadLayerCsv(undefined, {
      onSuccess(csv: File) {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(csv)
        link.setAttribute('download', file.name || `layer-${layerid}.csv`)
        link.click()
        setTimeout(() => URL.revokeObjectURL(link.href))
      },
    })
  }

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      aria-label={t('panel.layers.download')}
      className={styles.downloadLayerDialog}
    >
      <Stack space="large">
        <div>
          <Heading>{t('download_layer_dialog.title')}</Heading>
          <Text>{t('download_layer_dialog.subtitle')}</Text>
        </div>
        <Flex justify="between" align="center">
          <Flex justify="between" align="center" className={styles.fileName}>
            <Icon name="stack-line" size="xl" />
            <Text component="span" >
              Descarga CSV
            </Text>
          </Flex>
          <button
            type="button"
            className={styles.downloadIcon}
            onClick={downloadCsv}
            disabled={status === 'loading'}
          >
            <Icon name="download-line" size="xl" />
          </button>
        </Flex>
      </Stack>
    </Dialog>
  )

}

DownloadLayerDialog.displayName = 'DownloadLayerDialog'
